/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { neuronsGetApiV3KnownNeuronsNeuronIdBallots } from "../../funcs/neuronsGetApiV3KnownNeuronsNeuronIdBallots.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3KnownNeuronsNeuronIdBallotsRequest$inboundSchema,
};

export const tool$neuronsGetApiV3KnownNeuronsNeuronIdBallots: ToolDefinition<
  typeof args
> = {
  name: "neurons-get-api-v3-known-neurons-neuron-id-ballots",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await neuronsGetApiV3KnownNeuronsNeuronIdBallots(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
